<template>
  <div class="batchAdjustment">
    <div v-loading="loading" :element-loading-text="loadText">
      <div class="pad20_b err_price">
        <ul>
          <li v-for="item in errPriceList" :key="item.goodsId">{{ item.errMsg }}</li>
        </ul>
        <ul>
          <li v-for="item in errGoodList" :key="item.goodsId">{{ item.errMsg }}</li>
        </ul>
      </div>
      <el-form :model="tableForm" ref="tableForm">
        <div class="over_auto scrollbar">
          <div class="box20"></div>
          <el-table v-if="loaded" :data="tableForm.goodList" border style="width: 100%; min-width: 1300px">
            <el-table-column min-width="15%" label="货品名称">
              <template slot-scope="scope">
                <el-form-item :prop="`goodList.${scope.$index}.name`" :rules="tableRules.name">
                  <el-input
                    class="good_name"
                    clearable
                    maxlength="20"
                    @focus="goodNameBlur(scope.row)"
                    v-model="scope.row.name"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column min-width="8%" label="商品图">
              <template slot="header">
                <span class="relative cursor table_hint_wrap">
                  <i class="el-icon-warning-outline gray9"></i>
                  <span class="table_hint w165">只对商品第一张图进行管理</span>
                </span>
                <span class="pad5_l">商品图</span>
              </template>
              <template slot-scope="scope">
                <span v-if="scope.row.picUrl">
                  <span class="c_blue pad10_lr cursor" @click="onPreview(scope.row.picUrl)">预览</span>
                  <span class="c_blue pad10_lr cursor" @click="changeImg(scope.row.picUrl, scope.$index)">
                    <el-upload
                      class="upload-demo"
                      action="https://upload-z2.qiniup.com/"
                      :show-file-list="false"
                      :on-success="handleSuccess"
                      :before-upload="beforeUpload"
                      :on-remove="handleRemove"
                      :data="postData"
                    >
                      <span class="c_blue pad10_lr cursor">更换</span>
                      <!--@click="changeImg(scope.row.img,scope.$index)"-->
                    </el-upload>
                  </span>
                </span>
                <span v-else @click="changeImg(scope.row.img, scope.$index)">
                  <el-upload
                    class="upload-demo"
                    action="https://upload-z2.qiniup.com/"
                    :show-file-list="false"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    :on-remove="handleRemove"
                    :data="postData"
                  >
                    <span class="c_blue pad10_lr cursor">上传图片</span>
                    <!--@click="changeImg(scope.row.img,scope.$index)"-->
                  </el-upload>
                </span>
              </template>
            </el-table-column>
            <el-table-column min-width="10%" label="分类">
              <template slot="header">
                <span class="relative cursor table_hint_wrap">
                  <i class="el-icon-warning-outline gray9"></i>
                  <span class="table_hint w195">请在商品管理-分类管理进行设置</span>
                </span>
                <span class="pad5_l">分类</span>
              </template>
              <template slot-scope="scope">
                <el-select v-model="scope.row.goodsType" placeholder="请选择">
                  <el-option v-for="item in classifyList" :key="item.shopDecorateId" :label="item.name" :value="item.shopDecorateId"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column min-width="10%" label="价格">
              <!--el-icon-edit-outline-->
              <template slot="header">
                <span>价格</span>
                <span class="relative cursor table_hint_wrap" @click="batchAdjustment('price')">
                  <i class="el-icon-edit-outline pad5_l gray9"></i>
                  <span class="table_hint table_hint_price w116">点击批量调整价格</span>
                </span>
              </template>
              <template slot-scope="scope">
                <!--改变输入框的边框的样式-->
                <!--class="changeInput"-->
                <el-form-item :prop="`goodList.${scope.$index}.marketPrice`" :rules="tableRules.price">
                  <el-input
                    clearable
                    v-model="scope.row.marketPrice"
                    oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/,'$1$2.$3')"
                    @focus="goodNameBlur(scope.row)"
                    :disabled="scope.row.isoa"
                  >
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column min-width="8%" label="计量单位">
              <template slot-scope="scope">
                <el-select v-model="scope.row.mUnit" filterable placeholder="请选择">
                  <el-option v-for="item in scope.row.unitsList" :key="item.unitsCode" :label="item.unitsName" :value="item.unitsCode"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column min-width="8%" label="库存">
              <template slot="header">
                <span>库存</span>
                <span class="relative cursor table_hint_wrap">
                  <i class="el-icon-edit-outline pad5_l gray9" @click="batchAdjustment('inventory')"></i>
                  <span class="table_hint table_hint_price w116">点击批量调整库存</span>
                </span>
              </template>
              <template slot-scope="scope">
                <div v-if="!scope.row.isoa">
                  <el-form-item :prop="`goodList.${scope.$index}.origNum`" :rules="tableRules.inventory">
                    <el-input
                      clearable
                      v-model="scope.row.origNum"
                      oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/,'$1$2.$3')"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </div>
                <div v-else>
                  <el-select v-model="scope.row.stockType" filterable placeholder="请选择">
                    <el-option v-for="item in inventory" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                  </el-select>
                  <el-form-item :prop="`goodList.${scope.$index}.origNum`" :rules="tableRules.inventory">
                    <el-input
                      class="mar10_t"
                      v-if="scope.row.stockType === 1"
                      clearable
                      oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/,'$1$2.$3')"
                      v-model="scope.row.origNum"
                      placeholder="请输入"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="isOffStand" min-width="8%" label="销售单位">
              <template slot-scope="scope">
                <el-select v-model="scope.row.sUnit" filterable placeholder="请选择">
                  <el-option v-for="item in scope.row.unitsList" :key="item.unitsCode" :label="item.unitsName" :value="item.unitsCode"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column v-if="isOffStand" min-width="8%" label="换算比例">
              <template slot="header">
                <span class="relative cursor table_hint_wrap">
                  <i class="el-icon-warning-outline gray9"></i>
                  <span class="table_hint w368">销售单位与计量单位的换算比例，如：70公斤/头，换算比例为70</span>
                </span>
                <span class="pad5_l">换算比例</span>
              </template>
              <template slot-scope="scope">
                <el-input
                  clearable
                  v-model="scope.row.unitConver"
                  oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/,'$1$2.$3')"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column v-if="shopDtl.isSetWxFee" min-width="8%" label="微信支付">
              <template slot="header">
                <span class="relative cursor table_hint_wrap">
                  <i class="el-icon-warning-outline gray9"></i>
                  <span class="table_hint w320">启用后该商品支持微信支付，您将承担千分之六的手续费</span>
                </span>
                <span class="pad5_l">微信支付</span>
              </template>
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isAssumeWxFee" active-color="#2e86ff" inactive-color="#cccccc" :active-value="1" :inactive-value="0"> </el-switch>
              </template>
            </el-table-column>
            <el-table-column v-if="isFastPayment" min-width="8%" label="银行卡支付">
              <template slot="header">
                <span class="relative cursor table_hint_wrap">
                  <i class="el-icon-warning-outline gray9"></i>
                  <span class="table_hint w320">启用后该商品支持银行卡支付，您将承担(储蓄卡千分之三\信用卡千分之六)的手续费</span>
                </span>
                <span class="pad5_l">银行卡支付</span>
              </template>
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isAssumeCloudFee" active-color="#2e86ff" inactive-color="#cccccc" :active-value="1" :inactive-value="0">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column min-width="10%" label="配送模板">
              <template slot-scope="scope">
                <el-select v-model="scope.row.deliveryTemplateId" filterable placeholder="请选择">
                  <el-option v-for="item in deliveryList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column min-width="10%" label="运费">
              <template slot-scope="scope">
                <el-select v-model="scope.row.shopFreightTemplateId" filterable placeholder="请选择">
                  <el-option v-for="item in freightList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
          <div class="box10"></div>
        </div>
        <div class="box40"></div>
        <div class="t_center">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" :disabled="!isSubmit" @click="submitForm">提 交</el-button>
        </div>
      </el-form>
    </div>
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="[imgViewer]" />
    <el-drawer direction="rtl" :title="drawerTitle" :visible.sync="drawerDialog" custom-class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content">
        <el-form :model="drawerForm">
          <el-form-item label="调整方案：" label-width="120px">
            <el-radio-group v-model="drawerForm.method">
              <el-radio :label="1">按数值</el-radio>
              <el-radio :label="2">按比例</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="调整目标：" label-width="120px">
            <el-radio-group v-model="drawerForm.amend">
              <el-radio :label="1">增加</el-radio>
              <el-radio :label="2">降低</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="" label-width="120px">
            <el-input v-model="drawerForm.num"></el-input>
          </el-form-item>
        </el-form>
        <div class="demo-drawer_hint">
          <p v-if="drawerForm.method === 1">
            <span v-if="drawerForm.amend === 1">当前所有商品在原价格基础上增加{{ drawerForm.num }}</span>
            <span v-else>当前所有商品在原价格基础上减少{{ drawerForm.num }}</span>
          </p>
          <p v-else>
            <span v-if="drawerForm.amend === 1">当前所有商品在原价格基础上增加{{ drawerForm.num }}%</span>
            <span v-else>当前所有商品在原价格基础上减少{{ drawerForm.num }}%</span>
          </p>
        </div>
        <div class="demo-drawer__footer">
          <el-button @click="adjustmentCancel">取 消</el-button>
          <el-button type="primary" @click="adjustment">确 定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<!--scoped-->
<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
import { mapState } from "vuex";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: { ElImageViewer },
  data() {
    const self = this;
    // eslint-disable-next-line
    const validateName = (rule, value, callback) => {
      if (!value) {
        self.isSubmit = false;
        return callback(new Error("请输入货品名称"));
      }
      self.isSubmit = true;
      setTimeout(() => {
        self.$store
          .dispatch("orderTo/index/goodsNameCheck", {
            goodsId: self.curGoodsId,
            name: value,
          })
          .then((res) => {
            const isRepetition = res.code;
            if (isRepetition !== "0") {
              self.isSubmit = false;
              return callback(new Error("该货品名称已存在"));
            }
            self.isSubmit = true;
            return "";
          });
      }, 100);
    };
    // eslint-disable-next-line
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        self.isSubmit = false;
        return callback(new Error("请输入价格"));
      }
      self.isSubmit = true;
      setTimeout(() => {
        console.log(self.curGoodsId);
        self.$store
          .dispatch("orderTo/index/goodsNameCheck", {
            goodsId: self.curGoodsId,
            marketPrice: value,
          })
          .then((res) => {
            const isRepetition = res.code;
            const errMsg = res.msg;
            if (isRepetition !== "0") {
              self.isSubmit = false;
              return callback(new Error(errMsg));
            }
            self.errPriceList.forEach((item, index) => {
              if (item.goodsId === self.curGoodsId) {
                self.errPriceList.splice(index, 1);
              }
            });
            return "";
          });
      }, 100);
    };
    // eslint-disable-next-line
    const validateInventory = (rule, value, callback) => {
      if (!value) {
        self.isSubmit = false;
        return callback(new Error("请输入库存"));
      }
      if (Number(value) === 0) {
        self.isSubmit = false;
        return callback(new Error("库存不能为0"));
      }
      self.isSubmit = true;
    };
    return {
      loaded: false,
      errGoodList: [], // 提交后编辑失败的商品
      loading: true,
      loadText: "加载中",
      errPriceList: [], // 批量修改价格点击提交按钮时的错误提示
      isSubmit: true, // 是否可以提交
      curGoodsId: "", // 当前校验名称价格的商品id
      tableForm: {
        goodList: [], // 编辑商品列表
      },
      tableData: [], // 默认初始数据
      tableRules: {
        // 货品名称
        name: [{ validator: validateName, trigger: "blur" }],
        // 价格
        price: [{ validator: validatePrice, trigger: "blur" }],
        // 库存
        inventory: [{ validator: validateInventory, trigger: "blur" }],
      },
      classifyList: [], // 店铺分类
      shopDtl: {}, // 店铺详情
      isOffStand: 0, // 是否启用非标设置
      isFastPayment: 0, // 是否启用银行卡支付
      deliveryList: [], // 配送模板
      freightList: [], // 运费模板
      inventory: [
        {
          name: "不启用库存",
          value: 0,
        },
        {
          name: "销售库存",
          value: 1,
        },
        {
          name: "启用管理库存",
          value: 2,
        },
      ], // 库存的选择列表
      drawerTitle: "批量调价", // 批量调整库存
      drawerType: "price", // inventory 库存 price 价格
      drawerDialog: false,
      drawerForm: {
        method: 1,
        amend: 1,
        num: "",
      },
      curIndex: 0, // 当前点击的index
      origin: process.env,
      imageUrl: "",
      postData: {
        token: "",
      },
      uploadVisible: false, // 是否显示上传图片弹窗
      imgViewer: "", // 预览大图的地址
      showViewer: false, // 是否显示预览大图
    };
  },
  computed: mapState({
    showTitle: (state) => state.app.showTitle,
  }),
  created() {
    const { goodsId, isSpu } = this.$route.query;
    this.goodsToken();
    this.getGoodList(goodsId, isSpu);
    this.getDelAndFre();
    // getDeliveryTemplateList toFreightFormworkList
  },
  watch: {
    errPriceList() {
      if (this.errPriceList.length) {
        this.isSubmit = false;
      } else {
        this.isSubmit = true;
      }
      console.log(this.isSubmit);
    },
  },

  mounted() {},
  methods: {
    submitForm() {
      this.errGoodList = [];
      this.loading = true;
      this.loadText = "提交中";
      const { goodList } = this.tableForm;
      const submitList = goodList.map((item) => ({
        goodsId: item.goodsId,
        name: item.name,
        picUrl: item.picUrl,
        goodsType: item.goodsType || "",
        marketPrice: item.marketPrice,
        mUnit: item.mUnit,
        stockType: item.stockType,
        origNum: item.origNum,
        sUnit: item.sUnit || "",
        unitConver: item.unitConver || "",
        isAssumeWxFee: item.isAssumeWxFee,
        deliveryTemplateId: item.deliveryTemplateId,
        shopFreightTemplateId: item.shopFreightTemplateId,
        isAssumeCloudFee: item.isAssumeCloudFee,
      }));
      console.log(submitList);
      this.$store.dispatch("orderTo/index/GoodBatchEdit", submitList).then((res) => {
        console.log(res);
        this.loading = false;
        if (!res.data.length) {
          // `${this.origin.VUE_APP_APP}/mj/toGoodsMJ.do`
          const { isShowTitle } = this.$route.query;
          const url = isShowTitle === "1" ? `${this.origin.VUE_APP_APP}/mj/toGoodsMJ.do?appid=1` : `${this.origin.VUE_APP_APP}/mj/toGoodsMJ.do`;
          window.location.href = url;
        } else {
          const dataList = res.data;
          const editList = [];
          dataList.forEach((item) => {
            goodList.forEach((item1) => {
              if (item1.goodsId === item.goodsId) {
                editList.push(item1);
                this.errGoodList.push({
                  errMsg: `${item1.name}${item.msg}`,
                  goodsId: item1.goodsId,
                });
              }
            });
          });
          this.tableForm.goodList = editList;
          this.$message({
            message: "部分商品编辑失败请重试",
            type: "warning",
          });
        }
      });
    },
    cancelForm() {
      const { isShowTitle } = this.$route.query;
      const url = isShowTitle === "1" ? `${this.origin.VUE_APP_APP}/mj/toGoodsMJ.do?appid=1` : `${this.origin.VUE_APP_APP}/mj/toGoodsMJ.do`;
      window.location.href = url;
    },
    // 点击商品名称/价格---商品id
    goodNameBlur(item) {
      this.isSubmit = false;
      this.curGoodsId = item.goodsId;
    },
    // 调整价格/库存点击取消
    adjustmentCancel() {
      this.errPriceList = [];
      this.drawerForm.num = "";
      this.drawerForm.method = 1;
      this.drawerForm.amend = 1;
      this.drawerDialog = false;
    },
    // 确定调整
    // eslint-disable-next-line
    adjustment() {
      this.isSubmit = true;
      this.errPriceList = [];
      const { method, amend, num } = this.drawerForm;
      if (!num) {
        this.$message({
          message: "请输入调整数值",
          type: "warning",
        });
        return false;
      }
      let adjNum = "";
      if (method === 1) {
        adjNum = amend === 1 ? parseFloat(num) : -parseFloat(num);
      } else {
        adjNum = amend === 1 ? (parseFloat(num) + 100) / 100 : (100 - parseFloat(num)) / 100;
      }
      console.log(adjNum);
      this.tableForm.goodList.forEach((item, index) => {
        if (this.drawerType === "price") {
          // 调整价格
          let adjAfter = method === 1 ? parseFloat(item.marketPrice) + adjNum : item.marketPrice * adjNum;
          adjAfter = adjAfter > 0 ? adjAfter : 0;
          // 最多保留四位小数
          adjAfter = String(adjAfter).replace(/^(.*\..{4}).*$/, "$1");
          adjAfter = Number(adjAfter);
          //          adjAfter = adjAfter.toFixed(4);
          console.log("价格", adjAfter);
          item.marketPrice = item.isoa ? item.marketPrice : adjAfter;
          this.$set(this.tableForm.goodList, index, item);
          this.$store
            .dispatch("orderTo/index/goodsNameCheck", {
              goodsId: item.goodsId,
              marketPrice: item.marketPrice,
            })
            .then((res) => {
              if (res.code !== "0") {
                this.errPriceList.push({
                  goodsId: item.goodsId,
                  errMsg: `${item.name}${res.msg}`,
                });
                this.isSubmit = false;
              }
            });
        } else {
          // 调整库存
          let adjAfter = method === 1 ? parseFloat(item.origNum) + adjNum : item.origNum * adjNum;
          adjAfter = adjAfter > 0 ? adjAfter : 0;
          adjAfter = String(adjAfter).replace(/^(.*\..{4}).*$/, "$1");
          adjAfter = Number(adjAfter);
          //          adjAfter = adjAfter.toFixed(4);
          console.log("库存", adjAfter);
          // eslint-disable-next-line
          item.origNum = item.isoa ? (item.origNum ? adjAfter : item.origNum) : adjAfter;
          this.$set(this.tableForm.goodList, index, item);
        }
      });
      if (this.tableForm.goodList.some((item) => item.origNum === 0) && this.drawerType === "inventory") {
        this.$message({
          message: "库存不能为0",
          type: "warning",
        });
      }
      this.drawerForm.num = "";
      this.drawerForm.method = 1;
      this.drawerForm.amend = 1;
      this.drawerDialog = false;
    },
    // 批量调整价格/库存
    batchAdjustment(name) {
      this.drawerType = name;
      this.drawerDialog = true;
      if (name === "price") {
        this.drawerTitle = "批量调价";
      } else {
        this.drawerTitle = "批量调整库存";
      }
    },
    // 获取店铺信息
    getDelAndFre() {
      // queryShopClassify
      this.$store
        .dispatch("orderTo/index/queryShopClassify", {
          functionType: 2,
        })
        .then((res) => {
          console.log("店铺信息和店铺分类", res);
          const { shopClassifyList, shopDtl } = res;
          this.classifyList = shopClassifyList || {};
          this.shopDtl = shopDtl || [];
          shopDtl.shopFuncSetting.forEach((item) => {
            if (item.key === "is_off_stand") {
              console.log("非标设置", item);
              this.isOffStand = parseFloat(item.value);
            }
            if (item.key === "is_fast_payment") {
              console.log("银行卡支付", item);
              this.isFastPayment = parseFloat(item.value);
            }
          });
        });
      this.$store.dispatch("orderTo/index/getDeliveryTemplateList").then((res) => {
        console.log("配送模板", res);
        const { deliveryTemplateList } = res;
        this.deliveryList = deliveryTemplateList || [];
      });
      this.$store.dispatch("orderTo/index/toFreightFormworkList").then((res) => {
        console.log("运费模板", res);
        const { goodsFreightJO } = res;
        this.freightList = goodsFreightJO.data || [];
      });
    },
    // 获取编辑商品列表
    getGoodList(goodsId, isSpu) {
      this.$store
        .dispatch("orderTo/index/getGoodList", {
          goodsIds: goodsId,
          isSpu: isSpu,
        })
        .then((res) => {
          this.loading = false;
          console.log("商品列表", res);
          const dataList = res.data || [];
          this.tableForm.goodList = JSON.parse(JSON.stringify(dataList));
          this.tableData = JSON.parse(JSON.stringify(dataList));
          this.tableForm.goodList.forEach((item, index) => {
            item.sUnit = item.sUnit === "0" ? "" : item.sUnit;
            item.mUnit = item.mUnit === "0" ? "" : item.mUnit;
            // eslint-disable-next-line
          item.goodsType = item.goodsType == 0 ? '' : Number(item.goodsType);
            item.isoa = Boolean(item.isoa);
            item.origNum = parseFloat(item.origNum);
            this.loaded = false;
            this.$store
              .dispatch("orderTo/index/getUnitsList", {
                categoryId: item.categoryId,
              })
              .then((res1) => {
                console.log("分类和计量单位", res1);
                const { unitsList } = res1;
                item.unitsList = unitsList || [];
                this.$set(this.tableForm.goodList, index, item);
                setTimeout(() => {
                  this.loaded = true;
                }, 600);
              });
          });
        });
    },
    // 获取上传文件时候的token
    goodsToken() {
      this.$store.dispatch("app/getUploadToken").then((data) => {
        this.postData.token = data;
      });
    },
    // 上传成功后在图片框显示图片
    handleSuccess(res) {
      this.$message({
        message: "图片上传成功",
        type: "success",
      });
      this.imageUrl = `${this.origin.VUE_APP_IMGURL}${res.key}`;
      const { goodList } = this.tableForm;
      goodList[this.curIndex].picUrl = this.imageUrl;
      this.$set(this.tableForm, "goodList", goodList);
    },
    // 删除图片
    handleRemove() {
      this.imageUrl = "";
    },
    // 上传图片之前
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message({
          message: "上传图片大小不能超过 2MB",
          type: "warning",
        });
      } else if (!isJPG && !isPNG) {
        this.$message({
          message: "上传图片必须是JPG/PNG 格式",
          type: "warning",
        });
      }
      return (isJPG || isPNG) && isLt2M;
    },
    // 点击更换图片
    changeImg(img, index) {
      this.curIndex = index;
      this.imageUrl = img;
    },
    // 点击预览大图
    onPreview(img) {
      this.imgViewer = img;
      this.showViewer = true;
    },
    // 关闭预览大图
    closeViewer() {
      this.showViewer = false;
    },
  },
};
</script>
